import React from 'react'
import { Box, Typography } from '@mui/material'
import { useAppSelector } from '../../../redux/store'
import { selectLastUpdateInfo } from '../../../redux/teamMember/selector'
import { setDateFormat, setTimeFormat } from '../../../utils/dateUtils'

interface LastUpdateInfoProps {
  show?: boolean
}

const LastUpdateInfo: React.FC<LastUpdateInfoProps> = ({ show = true }) => {
  const lastUpdateInfo = useAppSelector(selectLastUpdateInfo)

  if (!show || !lastUpdateInfo) {
    return null
  }

  const formatLastUpdateDate = (dateString: string): string => {
    const date = setDateFormat(dateString)
    const time = setTimeFormat(dateString)
    return `${date} at ${time}`
  }

  const parseFilename = (filename: string) => {
    // Parse filename format: "filename.csv. Anthony Asentista"
    const parts = filename.split('. ')
    if (parts.length >= 2) {
      return {
        filename: parts[0],
        uploader: parts.slice(1).join('. ')
      }
    }
    return {
      filename: filename,
      uploader: null
    }
  }

  const { filename, uploader } = parseFilename(lastUpdateInfo.filename)

  return (
    <Box
      sx={{
        px: 2,
        py: 1,
        backgroundColor: 'white',
        borderBottom: '1px solid #e0e0e0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: 1,
      }}
    >
      <Typography
        variant="body2"
        sx={{
          color: '#666',
          fontSize: '0.75rem',
          fontWeight: 500,
        }}
      >
        Last Updated:
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: '#666',
          fontSize: '0.75rem',
          fontWeight: 500,
        }}
      >
        {formatLastUpdateDate(lastUpdateInfo.date)}
      </Typography>
      {uploader && (
        <>
          <Typography
            variant="body2"
            sx={{
              color: '#666',
              fontSize: '0.75rem',
              fontWeight: 500,
            }}
          >
            •
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: '#666',
              fontSize: '0.75rem',
              fontWeight: 500,
            }}
          >
            {uploader}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: '#666',
              fontSize: '0.75rem',
              fontWeight: 500,
            }}
          >
            •
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: '#666',
              fontSize: '0.75rem',
              fontWeight: 500,
            }}
          >
            {filename}
          </Typography>
        </>
      )}
      {!uploader && (
        <>
          <Typography
            variant="body2"
            sx={{
              color: '#666',
              fontSize: '0.75rem',
              fontWeight: 500,
            }}
          >
            •
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: '#666',
              fontSize: '0.75rem',
              fontWeight: 500,
            }}
          >
            {filename}
          </Typography>
        </>
      )}
    </Box>
  )
}

export default LastUpdateInfo
